import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyByMtD2b0yxFZesm3REpI_9rwEq3sxpYIw",
  authDomain: "labsantabarbaracr.firebaseapp.com",
  projectId: "labsantabarbaracr",
  storageBucket: "labsantabarbaracr.appspot.com",
  messagingSenderId: "943481016454",
  appId: "1:943481016454:web:c284c9bfa6621ca14bc107",
  measurementId: "G-0209VXMB13"
};

const app = initializeApp(firebaseConfig);
const secondaryApp = initializeApp(firebaseConfig, "SecondaryApp");
export const auth = getAuth(app);
export const database = getFirestore(app);
export const secondaryAuth = getAuth(secondaryApp);
export const storage = getStorage(app);